import fi from 'vuetify/src/locale/fi';
import { UserVuetifyPreset } from 'vuetify';

export default {
  theme: {
    options: {
      customProperties: true,
    },
    dark: false,
    themes: {
      light: {
        primary: '#00236d',
        secondary: '#4f4f4f',
        accent: '#00236d',
        error: '#e13e3f',
        info: '#0047df',
        success: '#388538',
        warning: '#ffae00',
      },
      dark: {
        primary: '#00236d',
        secondary: '#4f4f4f',
        accent: '#00236d',
        error: '#e13e3f',
        info: '#0047df',
        success: '#388538',
        warning: '#ffae00',
      },
    },
  },
  lang: {
    locales: { fi },
    current: 'fi',
  },
} as Partial<UserVuetifyPreset>;
